import { Component, OnDestroy, OnInit, Output, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Subject, Subscription } from 'rxjs';
import { DashboardSupersendComponent } from '../../dash-board/dashboard-supersend/dashboard-supersend.component';
import { currentcartdetail, ShopingCart } from '../../models/dashboard/cart/mywallet.currentcart.Modal';
import { CardDetails, PickupType, SendMoneyDetail, SendMoneySteps, StoreDetails, AdditionalRequired, OldOrderData } from '../../models/sendmoney/sendmoney';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings, enumStatusCodeList, PaymentType, OrderData } from '../../sharedcomponents/_common/constants/app.constants';
import { AlertPopupComponent } from '../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { ErrorPopupComponent } from '../../sharedcomponents/_directive/error-popup/error-popup.component';
import { AmountFormat, MyCurrencyPipe } from '../../sharedcomponents/_pipe/mycurreny';
import { CartServiceService } from '../../_services/dashboardservice/cart/cart-service.service';
import { ICE_DebitCard, mywalletcard } from '../../_services/mywallet/card/mywallet.card.service';
import { mywalletstore } from '../../_services/mywallet/store/mywallet.store.service';
import { RepeatorderService } from '../../_services/repeatorder/repeatorder.service';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { PayagainFailedorderService } from '../../_services/transaction/payagain-failedorder.service';
import { TransactionHistoryService } from '../../_services/transaction/transaction-history.service';
import { UserStateService } from '../../_services/userservice/userstateservice';
import { AdditionalInfoPopupComponent } from 'app/sendmoney/_modalpopup/additional-info-popup/additional-info-popup.component';
import { geolocation } from 'app/sharedcomponents/commonservice/geolocation/geoloc';
import { UserProfileTMNIovation, enumEventype } from 'app/models/user/user.tm.profile.model';
import { UserGioLocation } from 'app/models/user/usergioLocation';
import { AuthService } from 'app/_services/userservice/auth.service';
import { dashboardlandingpageservice } from 'app/_services/dashboardservice/dash-board.service';
import { InfoPopupComponent } from 'app/sharedcomponents/_directive/info-popup/info-popup.component';
import { Ng2DeviceService } from "ng2-device-detector";

declare var $: any;
@Component({
    selector: 'app-repeatorderlist',
    templateUrl: './repeatorderlist.component.html',
    styleUrls: ['./repeatorderlist.component.css'],
    providers: [Modal, CountryService, mywalletcard, mywalletstore, MyCurrencyPipe, AmountFormat, AuthService, dashboardlandingpageservice]
})
export class RepeatorderlistComponent implements OnInit, OnDestroy {
    isFormValid = true;
    srcRadio: boolean;
    dstRadio: boolean;
    sendMoneyDetail: SendMoneyDetail;
    transcationlist: any = [];
    isFirstLoad = true;
    BeneficiaryData: any = {};
    // paymentDetails: any = {}; // PaymentDetails;
    Rate: number;
    Fee: number;
    TaxAmount: number;
    paymentType: any;
    appSettings: any;
    OrderDetail: any = {};
    Beneficiary: any = {};
    countrycollection: any;
    flagVisible: boolean = false;
    cardDetail: CardDetails;
    storeDetail: any = {};
    BranchDetails: any = {};
    currentcart: currentcartdetail;
    subModalpopup: any;
    subSendMoneyDetail: any;
    subCurrentcartDetail: any;
    action = '';

    benificaryID;
    orderID;
    isPaymentAvalable = false; // it returns, payment option avalable or not
    isBranchAvalable = false; // it returns, branch option avalable or not
    isPaymentEdit = false;
    isModalOpen = false;
    transcation: any = {};
    unSubBranch: any;
    mobileScreen = false;
    showBothScreen = false;
    enableBackButton = false;
    private subBranch = new Subject<branchStatus>();
    @Output()
    observableBranch = this.subBranch.asObservable();

    unSubsubPaymentType: any;
    private subPaymentType = new Subject<boolean>();
    @Output()
    observablesubPaymentType = this.subPaymentType.asObservable();

    selectedIndex;
    PageFlow: any = {};
    RoundingPlaces: number = AppSettings.fractionDigit;
    model: any = {};

    actionFlag: boolean = false; // it notifies weather it is for add to cart or supersend call in branch details
    isDocUploaded: boolean = false;
    DocumentRequired: {};
    isBranchDetailsUpdated: boolean = false;
    isGeolocationUpdated: boolean = false;
    userProfileTMNIovation: UserProfileTMNIovation;
    shopingCart: ShopingCart;
    subscription: Subscription;
    fraudSubAddbank: Subscription;
    fraudSubPay: Subscription;
    unsubjectShoppingCart: Subscription;
    private subjectShoppingCart = new Subject<boolean>();
    @Output()
    subjectShoppingCartObservable = this.subjectShoppingCart.asObservable();

    private clickStream = new Subject<boolean>();
    @Output()
    observable = this.clickStream.asObservable();

    unsubGeoPermisson: any;
    private subGeoPermisson = new Subject<boolean>();
    @Output()
    observableGeoPermisson = this.subGeoPermisson.asObservable();

    private subfraudPay = new Subject<boolean>();
    @Output()
    subfraudPayObservable = this.subfraudPay.asObservable();

    private subfraudAddbank = new Subject<boolean>();
    @Output()
    subfraudSubAddbank = this.subfraudAddbank.asObservable();

    private subSupersendCall = new Subject<boolean>();
    orderData: OrderData = new OrderData();
    oldOrderData: OldOrderData = new OldOrderData();
    srcAmount: number;
    constructor(
        public utilityServ: utilityService,
        private router: Router,
        public repeatOrder: RepeatorderService,
        public transHistoryServ: TransactionHistoryService,
        public translate: TranslateService,
        private sendMoneyService: SendMoneyService,
        public modal: Modal,
        private countryserv: CountryService,
        private cardservice: mywalletcard,
        private storeservice: mywalletstore,
        private userStateService: UserStateService,
        public payeagainservice: PayagainFailedorderService,
        private currencyPipe: MyCurrencyPipe,
        private amountFormat: AmountFormat,
        private cartservice: CartServiceService,
        private vcRef: ViewContainerRef,
        private geoloc: geolocation,
        private auth: AuthService,
        private deviceService: Ng2DeviceService,
        private dbService: dashboardlandingpageservice
    ) {
        this.srcRadio = true;
        this.paymentType = PaymentType;
        this.appSettings = AppSettings;
        this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
        this.sendMoneyDetail = new SendMoneyDetail();
        // this.paymentDetails = this.sendMoneyDetail.paymentDetails;
        this.Rate = Number(this.sendMoneyDetail.paymentDetails.exchangeRate);
        this.Fee = this.sendMoneyDetail.paymentDetails.processingFee;

        const _self = this;
        _self.subSendMoneyDetail = this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
            this.sendMoneyDetail = data;
            this.flagVisible = true;
            if (_self.subSendMoneyDetail != undefined) {
                _self.subSendMoneyDetail.unsubscribe();
            }
        });
        const activePath = this.router.url.split('/')[1];
        this.sendMoneyService.setRepeatOrderFlow(activePath);
        let repeatOrderFlowsubs = this.sendMoneyService.getRepeatOrderFlow().subscribe(data => {
            this.PageFlow = data;
            sessionStorage.RepeatOrderFlow = data.Value;

            if (repeatOrderFlowsubs) {
                repeatOrderFlowsubs.unsubscribe();
            }

        });
        // this.paymentDetails = this.sendMoneyDetail.paymentDetails;
        let userDetailSubs = this.userStateService.getcurrentUserDetailData().subscribe(data => {
            this.sendMoneyDetail.userDetails = data;

            if (userDetailSubs) {
                userDetailSubs.unsubscribe();
            }
        });

        // branch observable happens when get branch service called
        this.unSubBranch = this.observableBranch.subscribe(x => {
            const _self = this;
            if (x == branchStatus.branchAvailable) {
                // success code
                _self.updateBranchDetails();
                _self.isBranchAvalable = true;
                // _self.checkPaymentDetails();
            } else if (x == branchStatus.branchAmountExeed) {
                _self.sendMoneyDetail.agentDetails.Amount = 0;
                _self.getBranchDetail();
            } else if (x == branchStatus.branchNotAvailable) {
                _self.sendMoneyDetail.agentDetails.Amount = 0;
                _self.sendMoneyDetail.agentDetails.LocationId = 0;
                _self.getBranchDetail();
            } else if (x == branchStatus.branchNotExist) {

                _self.sendMoneyDetail.agentDetails.Amount = 0;
                _self.sendMoneyDetail.paymentDetails.srcAmount = 0;
                _self.sendMoneyDetail.paymentDetails.destAmount = 0;
                _self.sendMoneyDetail.paymentDetails.totalAmount = 0;
                _self.sendMoneyDetail.paymentDetails.processingFee = 0;
                this.model.srcAmount = this.amountFormat.transform(this.sendMoneyDetail.paymentDetails.srcAmount.toString());
                this.Rate = Number(this.sendMoneyDetail.paymentDetails.exchangeRate);
                this.Fee = this.sendMoneyDetail.paymentDetails.processingFee;
                //this.valueChangeForward();


                const modalData: any = {};
                modalData.Title = _self.translate.instant('Common_lblInfo').toString();
                modalData.Message = _self.translate.instant('RepeatOrderDetail_noBranchDesc').toString();
                modalData.Action = _self.translate.instant('RepeatOrderDetail_btnNoBranch').toString();
                return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                    obj.onDestroy.subscribe(data => {
                        _self.subModalpopup = _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupCenter);
                        _self.router.navigate(['/repeatorder']);
                        return;
                    });
                });
            } else if (x == branchStatus.unknown) {
                let modalData: any = {};
                modalData.Action = _self.translate.instant('Common_lblOk');
                modalData.Title = _self.translate.instant('Common_lblOops').toString();
                modalData.Message = _self.translate.instant('Message_errorMessage').toString();
                return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                    obj.onDestroy.subscribe(data => { });
                });
            }
            // if (_self.unSubBranch != undefined) {
            //   _self.unSubBranch.unsubscribe();
            // }
        });

        // Payment observable happens when payment service(card and store) called
        this.unSubsubPaymentType = this.observablesubPaymentType.subscribe(x => {
            //console.log("repeat order ka no payment desc" + x);
            if (x == true) {
                // _self.getBranchDetail();
            } else {
                const modalData: any = {};
                modalData.Title = this.translate.instant('Common_lblInfo').toString();
                modalData.Message = this.translate.instant('RepeatOrderDetail_noPaymentDesc').toString();
                modalData.Action = this.translate.instant('RepeatOrderDetail_btnNoPayment').toString();
                return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                    obj.onDestroy.subscribe(data => {
                        _self.subModalpopup = _self.sendMoneyService.setModalPopup(SendMoneySteps.PaymentType);
                        _self.router.navigate(['/repeatorder']);
                        return;
                    });
                });
            }
            // if (this.unSubsubPaymentType != undefined) {
            //   this.unSubsubPaymentType.unsubscribe();
            // }
        });
    }
    ngOnInit() {
        const activePath = this.router.url.split('/')[1];
        this.getcartDetails();
        let benificaryData: any = {};

        if (sessionStorage.orderData != undefined) {
            this.orderData = JSON.parse(sessionStorage.orderData);
        }


        // if (activePath == 'repeatorderlisttrans' || activePath == 'repeatorderlistdashboard') {
        //   this.payeagainservice.getbeneficiaryforRepeatOrder().subscribe(data => {
        //     benificaryData = data;
        //     sessionStorage.benificaryData = JSON.stringify(benificaryData);
        //   });

        //   benificaryData = JSON.parse(sessionStorage.benificaryData);

        //   if (activePath == 'repeatorderlistdashboard') {
        //     this.orderID = this.utilityServ.getObjectText(benificaryData.RecentOrderNumber);
        //     this.benificaryID = this.utilityServ.getObjectText(benificaryData.Beneficiary.BeneficiaryId);
        //   } else {
        //     const failTrasArray = this.utilityServ.getArray(benificaryData);
        //     this.orderID = this.utilityServ.getObjectText(failTrasArray[0].OrderNumber);
        //     this.benificaryID = this.utilityServ.getObjectText(failTrasArray[0].BeneficiaryId);
        //   }
        //   const reqObject: any = {};
        //   reqObject.BenificiaryId = this.benificaryID;
        //   reqObject.OrderNo = this.orderID;
        //   this.getRepeatOrderlist(reqObject);
        // } else {
        //   const reqObject: any = {};
        //   reqObject.BenificiaryId = '';
        //   reqObject.OrderNo = '';
        //   this.getRepeatOrderlist(reqObject);
        // }

        this.getRepeatOrderlist(this.orderData);
    }

    getRepeatOrderlist(reqObject) {
        const _self = this;
        this.selectedIndex = 0;
        this.utilityServ.busy = this.repeatOrder.getRepeatorderlistservice(reqObject).subscribe(
            data => {
                const response = data.Envelope.Body.OutGoingTransactionResponse;
                if (response.StatusCode == 20001) {
                    return false;
                }
                if (response.StatusCode == enumStatusCodeList.SUCCESS) {
                    this.isFirstLoad = false;
                    if (response.BeneficiaryTransactions.BeneficiaryTransaction != undefined) {
                        let transList = _self.utilityServ.getArray(response.BeneficiaryTransactions.BeneficiaryTransaction);
                        const activePath = _self.router.url.split('/')[1];

                        // if (activePath == 'repeatorderlisttrans' || activePath == 'repeatorderlistdashboard') {
                        //   if (transList.length > 0) {
                        //     transList[0].RecentOrderAmount = transList[0].Orders.OrderDetail.TotalAmount;
                        //     transList[0].RecentOrderStatus = transList[0].Orders.OrderDetail.Current;
                        //     this.transcationlist = transList;

                        //     this.selectedIndex = 0;
                        //     if (this.sendMoneyDetail.agentDetails.CountryTo == '') {
                        //       this.getOrderDetails(transList[0]);
                        //     }

                        //   } else {

                        //   }
                        // } else {
                        //   this.transcationlist = transList;
                        // }
                        if (transList.length > 0) {
                            if (sessionStorage.orderData != undefined) {
                                _self.selectedIndex = 0;
                                _self.orderData = JSON.parse(sessionStorage.orderData);
                                transList[0].RecentOrderAmount = transList[0].Orders.OrderDetail.TotalAmount;
                                transList[0].RecentOrderStatus = transList[0].Orders.OrderDetail.Current;
                                _self.transcationlist = transList;
                                if (((_self.sendMoneyDetail.agentDetails.LocationId || 0) == 0) || ((_self.sendMoneyDetail.agentDetails.PayingAgentId || 0) == 0)) {
                                    _self.getOrderDetails(transList[0]);
                                }
                            } else {
                                _self.transcationlist = transList;
                            }
                        }


                        if (((_self.sendMoneyDetail.agentDetails.LocationId || 0) > 0) || ((_self.sendMoneyDetail.agentDetails.PayingAgentId || 0) > 0)) {
                            if (window.screen.width < Number(AppSettings.MOBILE_SCREEN_WIDTH)) {
                                _self.showBothScreen = true;
                                _self.mobileScreen = true;
                            }
                            if (_self.sendMoneyDetail.storeDetails.storeName != '' && _self.sendMoneyDetail.paymentDetails.fundingId != 0) {
                                _self.isPaymentAvalable = true;
                            }

                            _self.getBranchDetail();



                        }
                    } else {
                        // this.errorPopup();
                    }
                } else {
                    _self.isFormValid = false;
                    // this.errorPopup();
                }
            },
            error => { }
        );
    }

    checkPaymentDetails() {
        if (this.sendMoneyDetail.paymentDetails.paymentType == PaymentType.DebitCard) {
            // && this.sendMoneyDetail.paymentDetails.fundingId == 0
            // this.getDebitCardDetailFromFundingID(this.sendMoneyDetail.paymentDetails.fundingId);
            this.getDebitCardDetail();
        }
        // && this.sendMoneyDetail.storeDetails.storeName == '' remove this from below line - every time store service will call to get store data.
        if (this.sendMoneyDetail.paymentDetails.paymentType == PaymentType.PayAtStore) {
            this.getStoreDetail();
        }

        //if ((this.sendMoneyDetail.branches == null || this.sendMoneyDetail.branches.length == 0) && this.isPaymentAvalable == true) {
        // if (this.isPaymentAvalable == true) {
        //   _self.getBranchDetail();
        // }

        if (Number(this.sendMoneyDetail.currentCartDetail.ItemCount) >= 1) {
            this.isPaymentEdit = false;
        } else {
            this.isPaymentEdit = true;
        }
    }
    getOrderDetails(transactionData) {
        const _self = this;
        // if (this.sendMoneyDetail.isData == false) {
        this.currentcart = new currentcartdetail();

        this.subCurrentcartDetail = this.sendMoneyService.getcurrentcartDetailData().subscribe(data => {
            _self.currentcart = data;
            _self.sendMoneyDetail.currentCartDetail = _self.currentcart;
            if (_self.subCurrentcartDetail != undefined) {
                _self.subCurrentcartDetail.unsubscribe();
            }
        });
        _self.getrepeatorderDetails(transactionData);
        // }
    }

    getcartDetails() {
        let curcarddetailresponsemodel = new currentcartdetail();
        this.utilityServ.busy = this.cartservice.getcarttypeservice().subscribe(
            data => {
                if (data.StatusCode == 20001) {
                    return false;
                }
                if (data.StatusCode == 10000) {
                    curcarddetailresponsemodel.CartExpiry = this.utilityServ.getObjectText(data.CartExpiry);
                    curcarddetailresponsemodel.CustmerPaymentMethod = this.utilityServ.getObjectText(data.CustmerPaymentMethod);
                    curcarddetailresponsemodel.FundingId = this.utilityServ.getObjectText(data.FundingId);
                    curcarddetailresponsemodel.GuaranteedCancellationPeriod = this.utilityServ.getObjectText(data.GuaranteedCancellationPeriod);
                    curcarddetailresponsemodel.ItemCount = this.utilityServ.getObjectText(data.ItemCount);
                    curcarddetailresponsemodel.StoreId = this.utilityServ.getObjectText(data.StoreId);
                    curcarddetailresponsemodel.StoreName = this.utilityServ.getObjectText(data.StoreName);
                    curcarddetailresponsemodel.SuperSend = this.utilityServ.getObjectText(data.SuperSend);
                    curcarddetailresponsemodel.UnReadMessageCount = this.utilityServ.getObjectText(data.UnReadMessageCount);
                    this.sendMoneyService.setcurrentcartDetailData(curcarddetailresponsemodel);
                }
            },
            error => { }
        );
    }

    getrepeatorderDetails(data: any) {
        const _self = this;
        let reqObject: any = {};
        const activePath = this.router.url.split('/')[1];

        // if (activePath == 'repeatorderlisttrans' || activePath == 'repeatorderlistdashboard') {
        //   reqObject.BenificiaryId = this.benificaryID;
        //   reqObject.OrderNo = this.orderID;
        // }
        if (sessionStorage.orderData != undefined) {
            this.orderData = JSON.parse(sessionStorage.orderData);
            reqObject.BenificiaryId = this.orderData.BenificiaryId;
            reqObject.OrderNo = this.orderData.OrderNo;
        } else {
            reqObject.BenificiaryId = this.utilityServ.getObjectText(data.Beneficiary.BeneficiaryId);
            reqObject.OrderNo = this.utilityServ.getObjectText(data.RecentOrderNumber);
        }

        if (window.screen.width < Number(AppSettings.MOBILE_SCREEN_WIDTH)) {
            this.showBothScreen = true;
            this.mobileScreen = true;
        }
        this.utilityServ.busy = this.repeatOrder.getRepeatorderlistservice(reqObject).subscribe(
            data => {
                const response = data.Envelope.Body.OutGoingTransactionResponse;
                if (response.StatusCode == 20001) {
                    return false;
                }
                if (response.StatusCode == enumStatusCodeList.SUCCESS) {
                    _self.flagVisible = true;
                    _self.Beneficiary = response.BeneficiaryTransactions.BeneficiaryTransaction.Beneficiary;
                    _self.OrderDetail = response.BeneficiaryTransactions.BeneficiaryTransaction.Orders.OrderDetail;
                    _self.sendMoneyDetail.beneficiaryDetails = _self.Beneficiary;
                    _self.sendMoneyDetail.agentDetails.Amount = parseFloat(_self.utilityServ.getObjectText(_self.OrderDetail.AmountLocal));
                    _self.sendMoneyDetail.agentDetails.PayingAgentId = _self.utilityServ.getObjectText(_self.OrderDetail.PayingAgentId);
                    _self.sendMoneyDetail.agentDetails.AgentName = _self.utilityServ.getObjectText(_self.OrderDetail.PayingAgentName);
                    _self.sendMoneyDetail.bankAccountDetails.BankAccountNumber = _self.utilityServ.getObjectText(_self.OrderDetail.BankAccountNumber);
                    _self.sendMoneyDetail.bankAccountDetails.BankAccountType = _self.utilityServ.getObjectText(_self.OrderDetail.BankAccountType);
                    _self.sendMoneyDetail.bankAccountDetails.BankCity = _self.utilityServ.getObjectText(_self.OrderDetail.BankCity);
                    _self.sendMoneyDetail.bankAccountDetails.routingNumber = _self.utilityServ.getObjectText(_self.OrderDetail.BankCode);
                    _self.sendMoneyDetail.bankAccountDetails.BankName = _self.utilityServ.getObjectText(_self.OrderDetail.BankName);
                    _self.sendMoneyDetail.bankAccountDetails.BankId = _self.utilityServ.getObjectText(_self.OrderDetail.BankId);
                    _self.sendMoneyDetail.agentDetails.LocationId = _self.utilityServ.getObjectText(_self.OrderDetail.PayingAgentLocationId);
                    _self.sendMoneyDetail.agentDetails.CountryFrom = _self.utilityServ.getObjectText(_self.OrderDetail.CountryCodeFrom);
                    _self.sendMoneyDetail.agentDetails.CountryTo = _self.utilityServ.getObjectText(_self.OrderDetail.CountryCodeTo);



                    // _self.sendMoneyDetail.agentDetails.StateTo = _self.utilityServ.getObjectText(_self.OrderDetail.StateCodeTo);
                    // _self.sendMoneyDetail.agentDetails.CityTo = _self.utilityServ.getObjectText(_self.OrderDetail.CityTo);
                    // below logic has wriiten on 2 jun 2020 - As mahendra has confirmed with client
                    if (_self.utilityServ.getObjectText(_self.OrderDetail.StateCodeTo) == '*') {
                        _self.sendMoneyDetail.agentDetails.StateTo = _self.utilityServ.getObjectText(_self.Beneficiary.Addresses.StateCode);
                    } else {
                        _self.sendMoneyDetail.agentDetails.StateTo = _self.utilityServ.getObjectText(_self.OrderDetail.StateCodeTo);
                    }
                    if (_self.utilityServ.getObjectText(_self.OrderDetail.CityTo) == '*') {
                        _self.sendMoneyDetail.agentDetails.CityTo = _self.utilityServ.getObjectText(_self.Beneficiary.Addresses.CityCode);
                    } else {
                        _self.sendMoneyDetail.agentDetails.CityTo = _self.utilityServ.getObjectText(_self.OrderDetail.CityTo);
                    }


                    _self.sendMoneyDetail.agentDetails.CurrencyFrom = _self.utilityServ.getObjectText(_self.OrderDetail.CurrencyCodeFrom);
                    _self.sendMoneyDetail.agentDetails.CurrencyTo = _self.utilityServ.getObjectText(_self.OrderDetail.CurrencyCodeTo);
                    _self.sendMoneyDetail.agentDetails.CountrySupportedCurrencyCodesTo = _self.utilityServ.getObjectText(_self.OrderDetail.CurrencyCodeTo);

                    _self.sendMoneyDetail.paymentDetails.exchangeRate = _self.utilityServ.getObjectText(_self.OrderDetail.Rate);
                    _self.sendMoneyDetail.paymentDetails.totalAmount = Number(_self.utilityServ.getObjectText(_self.OrderDetail.TotalAmount));
                    _self.sendMoneyDetail.paymentDetails.destAmount = Number(_self.utilityServ.getObjectText(_self.OrderDetail.TransferAmount));
                    _self.sendMoneyDetail.paymentDetails.destAmount = Number(_self.utilityServ.getObjectText(_self.OrderDetail.fun));
                    _self.sendMoneyDetail.paymentDetails.fundingId = _self.utilityServ.getObjectText(_self.OrderDetail.FundingId);

                    if (Number(_self.sendMoneyDetail.currentCartDetail.ItemCount) >= 1) {
                        _self.sendMoneyDetail.paymentDetails.paymentType = _self.sendMoneyDetail.currentCartDetail.CustmerPaymentMethod;
                    } else {
                        _self.sendMoneyDetail.paymentDetails.paymentType = _self.utilityServ.getObjectText(_self.OrderDetail.CustomerPaymentMethod);
                    }

                    _self.sendMoneyDetail.paymentDetails.srcCurrCode = _self.utilityServ.getObjectText(_self.OrderDetail.CurrencyCodeFrom);
                    _self.sendMoneyDetail.paymentDetails.destCurrCode = _self.utilityServ.getObjectText(_self.OrderDetail.CurrencyCodeTo);
                    _self.sendMoneyDetail.paymentDetails.processingFee = Number(_self.utilityServ.getObjectText(_self.OrderDetail.Commission));
                    _self.sendMoneyDetail.paymentDetails.srcAmount = Number(_self.utilityServ.getObjectText(_self.OrderDetail.AmountLocal));

                    _self.sendMoneyDetail.pickupTypeDetails.pickupType = _self.utilityServ.getObjectText(_self.OrderDetail.DeliveryMethod);
                    _self.sendMoneyDetail.agentDetails.DeliveryMethod = _self.sendMoneyDetail.pickupTypeDetails.pickupType;

                    _self.sendMoneyDetail.pickupTypeDetails.countryPreference = _self.sendMoneyDetail.agentDetails.CountryTo;
                    _self.sendMoneyDetail.pickupTypeDetails.currencies = _self.sendMoneyDetail.agentDetails.CurrencyTo;
                    _self.sendMoneyDetail.pickupTypeDetails.countryName = _self.getCountryName(_self.sendMoneyDetail.agentDetails.CountryTo);

                    _self.sendMoneyDetail.agentDetails.Amount = _self.sendMoneyDetail.paymentDetails.srcAmount;
                    _self.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);

                    _self.oldOrderData.PickupType = _self.sendMoneyDetail.pickupTypeDetails.pickupType;
                    _self.oldOrderData.PaymentType = _self.sendMoneyDetail.paymentDetails.paymentType;
                    _self.oldOrderData.Amount = _self.sendMoneyDetail.paymentDetails.srcAmount;

                    _self.sendMoneyService.setRepeatorderOldData(_self.oldOrderData)
                    // if (_self.sendMoneyDetail.paymentDetails.paymentType == PaymentType.DebitCard) {
                    //   _self.getDebitCardDetail();
                    // } else {
                    //   _self.getStoreDetail();
                    // }


                    this.model.srcAmount = this.amountFormat.transform(this.sendMoneyDetail.paymentDetails.srcAmount.toString());
                    this.Rate = Number(this.sendMoneyDetail.paymentDetails.exchangeRate);
                    this.Fee = Number(this.sendMoneyDetail.paymentDetails.processingFee);
                    //this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));
                    if (_self.sendMoneyDetail.pickupTypeDetails.pickupType == 2) {
                        this.utilityServ.busy = this.sendMoneyService.getBankLogo(_self.sendMoneyDetail.bankAccountDetails).subscribe(data => {
                            // this.getpaymentDetails();
                            this.getBranchDetail();
                            let agentImgData = '';
                            if (data.HasDefaultImage == true) {
                                agentImgData = '';
                            } else {
                                agentImgData = 'data:image/gif;base64,' + data.BankImageData;
                            }
                            this.sendMoneyDetail.agentDetails.ImageData = agentImgData;
                            this.sendMoneyDetail.pickupCenterDetails.imgData = agentImgData;
                        });
                    } else {
                        this.utilityServ.busy = this.sendMoneyService.getPayerLogo(_self.sendMoneyDetail.agentDetails).subscribe(data => {
                            // this.getpaymentDetails();
                            this.getBranchDetail();
                            let agentImgData = '';
                            if (data.HasDefaultImage == true) {
                                agentImgData = '';
                            } else {
                                agentImgData = 'data:image/gif;base64,' + data.PayingAgentImageData;
                            }
                            this.sendMoneyDetail.agentDetails.ImageData = agentImgData;
                            this.sendMoneyDetail.pickupCenterDetails.imgData = agentImgData;
                        });
                    }
                } else {
                    this.isFormValid = false;
                }
            },
            error => { }
        );
    }

    timeout: any = null;
    public onKeySearch(event: any) {

      let _localAmtChanged = this.LocalAmountChanged()
      let _transferAmtChanged = this.TransferAmountChanged()

      if (_localAmtChanged || _transferAmtChanged) {

          clearTimeout(this.timeout);

          this.srcRadio = _localAmtChanged;
          this.dstRadio = _transferAmtChanged;

          var $this = this;

          $this.timeout = setTimeout(function () {

              if ((_localAmtChanged && !$this.model.srcAmount || isNaN($this.model.srcAmount)) || (_transferAmtChanged && !$this.model.destAmount || isNaN($this.model.destAmount))) {
                  $this.model.srcAmount = '0.00';
                  $this.model.destAmount = '0.00';
                  $this.sendMoneyDetail.paymentDetails.srcAmount = 0.00;
                  $this.sendMoneyDetail.paymentDetails.destAmount = 0.00;
                  $this.sendMoneyDetail.paymentDetails.totalAmount = 0.00;
              } else {

                  $this.TriggerAmountChanged();

              }

          }, 2000);
      }
    }

    private TriggerAmountChanged() {

        if (this.srcRadio === true) {
            this.valueChangeForward();
        }

        if (this.dstRadio === true) {
            this.valueChangeBackward();
        }
    }

    private LocalAmountChanged() {
        return this.AmountChanged(this.model.srcAmount, this.sendMoneyDetail.paymentDetails.srcAmount, 2);
    }

    private TransferAmountChanged() {
        return this.AmountChanged(this.model.destAmount, this.sendMoneyDetail.paymentDetails.destAmount, this.RoundingPlaces || 2);
    }

    private AmountChanged(_newAmount: any, _oldAmount: any, precision: number) {

        let _newAmountNumber: any = Number(_newAmount);
        let _oldAmountNumber: any = Number(_oldAmount);

        if (!isNaN(_newAmountNumber)) {
            _newAmountNumber = _newAmountNumber.toFixed(precision);
        }

        if (!isNaN(_oldAmountNumber)) {
            _oldAmountNumber = _oldAmountNumber.toFixed(precision);
        }

        if (isNaN(_newAmountNumber) && isNaN(_oldAmountNumber)) {
            return _newAmount !== _oldAmount;
        } else {
            return _newAmountNumber !== _oldAmountNumber;
        }
    }

    getpaymentDetails() {
        if (this.sendMoneyDetail.paymentDetails.paymentType == PaymentType.DebitCard) {
            this.getDebitCardDetail();
        } else {
            this.getStoreDetail();
        }
    }
    ValidateMobileScreen(screen) {
        if (this.mobileScreen == screen.mobileScreen) {
            return true;
        }
        this.showBothScreen = screen.showBothScreen;
        this.mobileScreen = screen.mobileScreen;
        this.enableBackButton = screen.enableBackButton;
    }
    updateBranchDetails() {
        // this.sendMoneyDetail.paymentDetails.processingFee = Number(this.sendMoneyDetail.branchDetails.CustomerFee);
        // this.sendMoneyDetail.paymentDetails.exchangeRate = this.sendMoneyDetail.branchDetails.RateCustomer.toString();
        this.Rate = Number(this.sendMoneyDetail.branchDetails.RateCustomer);
        this.Fee = Number(this.sendMoneyDetail.branchDetails.CustomerFee);
        if (this.sendMoneyDetail.branchDetails.MinimumDenomination != null) {
            this.sendMoneyDetail.paymentDetails.minimumDenomination = parseFloat(this.currencyPipe.parse(this.sendMoneyDetail.branchDetails.MinimumDenomination.toString()));
        } else {
            this.sendMoneyDetail.paymentDetails.minimumDenomination = 0;
        }

        if (this.sendMoneyDetail.branchDetails.MaximumLocalAmount != null) {
            this.sendMoneyDetail.paymentDetails.maxAllowedLimit = parseFloat(this.currencyPipe.parse(this.sendMoneyDetail.branchDetails.MaximumLocalAmount.toString()));
        } else {
            this.sendMoneyDetail.paymentDetails.maxAllowedLimit = 0;
        }
        if (!this.sendMoneyDetail.branchDetails.MaximumLocalAmountExcludeFee && this.sendMoneyDetail.paymentDetails.maxAllowedLimit > 0) {
            this.sendMoneyDetail.paymentDetails.maxAllowedLimit = this.sendMoneyDetail.paymentDetails.maxAllowedLimit - this.Fee;
        }

        if (this.sendMoneyDetail.paymentDetails.maxAllowedLimit == 0 || this.sendMoneyDetail.paymentDetails.maxAllowedLimit > parseFloat(this.sendMoneyDetail.userDetails.maxTransferAmountLimit)) {
            this.sendMoneyDetail.paymentDetails.maxAllowedLimit = parseFloat(this.currencyPipe.parse(this.sendMoneyDetail.userDetails.maxTransferAmountLimit));
        }
        // if (this.paymentDetails.srcAmount > this.paymentDetails.maxAllowedLimit) {
        //   this.paymentDetails.srcAmount = this.currencyPipe.parse(this.paymentDetails.maxAllowedLimit.toString());
        // }

        let conObj = this.countrycollection.filter(item => item.CountryCode == this.sendMoneyDetail.pickupTypeDetails.countryPreference);
        if (conObj.length > 0) {
            let curobj = conObj[0].Currencies.filter(item => item.CurrencyCode == this.sendMoneyDetail.agentDetails.CurrencyTo);
            if (curobj.length > 0) {
                this.RoundingPlaces = curobj[0].RoundingPlaces;
            }
        }

        this.model.srcAmount = this.sendMoneyDetail.paymentDetails.srcAmount;
        // this.model.destAmount = this.currencyPipe.parse(this.sendMoneyDetail.paymentDetails.destAmount.toString());
        // this.model.srcAmount = this.amountFormat.transform(this.model.srcAmount.toString());
        // this.model.destAmount = this.amountFormat.transform(this.model.destAmount.toString());

        this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));
        //this.valueChangeForward(true);

        // this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
        let self = this;
        self.sendMoneyDetail.paymentDetails.processingFee = Number(self.sendMoneyDetail.branchDetails.CustomerFee);
        self.sendMoneyDetail.paymentDetails.exchangeRate = self.sendMoneyDetail.branchDetails.RateCustomer.toString();
        self.checkPaymentDetails();
        // below code commented - Dated 02 Jun 2020 -mahendra has discussed with client and suggeted
        // if (
        //   Number(this.sendMoneyDetail.paymentDetails.exchangeRate).toFixed(2) == Number(this.sendMoneyDetail.branchDetails.RateCustomer).toFixed(2) &&
        //   Number(this.sendMoneyDetail.paymentDetails.processingFee).toFixed(2) == Number(this.sendMoneyDetail.branchDetails.CustomerFee).toFixed(2)
        // ) {
        //   self.sendMoneyDetail.paymentDetails.processingFee = Number(self.sendMoneyDetail.branchDetails.CustomerFee);
        //   self.sendMoneyDetail.paymentDetails.exchangeRate = self.sendMoneyDetail.branchDetails.RateCustomer.toString();
        //   self.checkPaymentDetails();
        // } else {
        //   let modalData: any = {};
        //   modalData.Title = this.translate.instant('Common_lblInfo');
        //   modalData.Message = this.translate.instant('ExchangeFeeReviewPopup_desc');
        //   modalData.Action = this.translate.instant('Common_lblOk');
        //   return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
        //     obj.onDestroy.subscribe(data => {
        //       self.checkPaymentDetails();
        //       self.sendMoneyDetail.paymentDetails.processingFee = Number(self.sendMoneyDetail.branchDetails.CustomerFee);
        //       self.sendMoneyDetail.paymentDetails.exchangeRate = self.sendMoneyDetail.branchDetails.RateCustomer.toString();
        //     });
        //   });
        // }
    }

    getBranchDetail() {
        let self = this;
        //console.log("Es el 7");
        this.utilityServ.busy = this.sendMoneyService.getBranchDetails(this.sendMoneyDetail.agentDetails).subscribe(
            data => {
                if (data.StatusCode == 20001) {
                    return false;
                }
                else if (data.StatusCode == 8000) {
                    this.subBranch.next(branchStatus.branchNotAvailable);
                }
                else if (data.StatusCode == 10000) {
                    if (data.Branches == null) {
                        this.subBranch.next(branchStatus.branchNotExist);
                    } else {
                        this.sendMoneyDetail.branchDetails = data.Branches[0];
                        this.sendMoneyDetail.branches = data.Branches;
                        this.sendMoneyDetail.branchDetails.TaxAmount = data.Branches[0].TaxAmount;
                        this.sendMoneyDetail.paymentDetails.TaxAmount = data.Branches[0].TaxAmount;
                        this.sendMoneyDetail.branchDetails.TaxDetails = data.Branches[0].TaxDetails;
                        this.sendMoneyDetail.paymentDetails.TaxDetails = data.Branches[0].TaxDetails;
                        this.subBranch.next(branchStatus.branchAvailable);
                    }

                } else {
                    // this.isFormValid = false;
                    this.subBranch.next(branchStatus.branchNotExist);
                }
            },
            error => { }
        );
    }

    getDebitCardDetailFromFundingID(fundingId) {
        this.utilityServ.busy = this.cardservice.getcardlistservice(this.utilityServ.getObjectText(fundingId)).subscribe(data => {
            if (data.Envelope.Body.GetFundingResponse.StatusCode == 20001) {
                return false;
            }
            if (data.Envelope.Body.GetFundingResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                if (data.Envelope.Body.GetFundingResponse.Fundings.Funding === undefined) {
                    this.subPaymentType.next(false);
                }
            }
        });
    }

    getDebitCardDetail() {
        let fundingId;
        if (Number(this.sendMoneyDetail.currentCartDetail.ItemCount) >= 1) {
            this.isPaymentEdit = false;
            fundingId = this.sendMoneyDetail.currentCartDetail.FundingId;
            this.sendMoneyDetail.paymentDetails.fundingId = fundingId;
        } else {
            this.isPaymentEdit = true;
        }

        this.utilityServ.busy = this.cardservice.getcardlistservice(this.utilityServ.getObjectText(this.sendMoneyDetail.paymentDetails.fundingId)).subscribe(
            data => {
                if (data.Envelope.Body.GetFundingResponse.StatusCode == 20001) {
                    return false;
                }
                if (data.Envelope.Body.GetFundingResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                    if (data.Envelope.Body.GetFundingResponse.Fundings.Funding != undefined) {
                        this.isFormValid = true;
                        this.cardDetail = new CardDetails();
                        this.cardDetail.cardFundingID = this.utilityServ.getObjectText(data.Envelope.Body.GetFundingResponse.Fundings.Funding.FundingId);
                        this.cardDetail.cardNickname = this.utilityServ.getObjectText(data.Envelope.Body.GetFundingResponse.Fundings.Funding.FriendlyName);
                        this.cardDetail.cardlastfournum = this.utilityServ.getObjectText(data.Envelope.Body.GetFundingResponse.Fundings.Funding.AccountNumber);
                        this.cardDetail.cardimageurl = AppSettings.imagefolder + ICE_DebitCard[this.utilityServ.getObjectText(data.Envelope.Body.GetFundingResponse.Fundings.Funding.SubType)] + '.png';
                        this.sendMoneyDetail.cardDetails = this.cardDetail;
                        this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                        this.subPaymentType.next(true);
                    } else {
                        this.isFormValid = false;
                        this.subPaymentType.next(false);
                    }
                } else {
                    this.isFormValid = false;
                }
            },
            error => { }
        );
    }

    getStoreDetail() {
        const _self = this;
        if (Number(this.sendMoneyDetail.currentCartDetail.ItemCount) >= 1) {
            this.isPaymentEdit = false;
        } else {
            this.isPaymentEdit = true;
        }
        this.utilityServ.busy = this.storeservice.getstorelistservice().subscribe(
            data => {
                if (data.Envelope.Body.StoresResponse.StatusCode == 20001) {
                    return false;
                }
                if (data.Envelope.Body.StoresResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                    let storeid = '';

                    storeid = _self.sendMoneyDetail.storeDetails.storeId;
                    if (_self.sendMoneyDetail.currentCartDetail.StoreId != '0') {
                        storeid = _self.sendMoneyDetail.currentCartDetail.StoreId;
                    }
                    _self.storeDetail = _self.utilityServ.getArray(data.Envelope.Body.StoresResponse.Stores.StoreDetail).filter(function (ele) {
                        return _self.utilityServ.getObjectText(ele.StoreID) == storeid;
                    })[0];
                    if (_self.storeDetail != undefined) {
                        let storeDetail: StoreDetails = _self.initializestore(_self.storeDetail);
                        _self.sendMoneyDetail.storeDetails = storeDetail;
                        _self.sendMoneyService.setSendMoneyDetailData(_self.sendMoneyDetail);
                        _self.subPaymentType.next(true);
                    } else {
                        _self.subPaymentType.next(false);
                    }
                } else {
                    _self.isFormValid = false;
                    let modalData: any = {};
                    modalData.Title = _self.translate.instant('Common_lblOops').toString();
                    modalData.Message = data.Envelope.Body.StoresResponse.StatusMessage;
                    _self.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
                }
            },
            error => { }
        );
    }

    initializestore(obj) {
        let storeDetails: StoreDetails = new StoreDetails();
        storeDetails.storeId = this.utilityServ.getObjectText(obj.StoreID);
        // storeDetails.storeaddress = obj.Address;
        storeDetails.storeaddress.Address1 = this.utilityServ.getObjectText(obj.Address.Address1);
        storeDetails.storeaddress.CityCode = this.utilityServ.getObjectText(obj.Address.City);
        storeDetails.storeaddress.CountryCode = this.utilityServ.getObjectText(obj.Address.CountryCode);
        storeDetails.storeaddress.Latitude = this.utilityServ.getObjectText(obj.Address.Latitude);
        storeDetails.storeaddress.Longitude = this.utilityServ.getObjectText(obj.Address.Longitude);
        storeDetails.storeaddress.StateCode = this.utilityServ.getObjectText(obj.Address.StateCode);
        storeDetails.storeaddress.ZipCode = this.utilityServ.getObjectText(obj.Address.ZipCode);
        storeDetails.storeName = this.utilityServ.getObjectText(obj.Name);
        storeDetails.storenotesSection = this.utilityServ.getObjectText(obj.Notes);
        storeDetails.storespecialInstructionSection = this.utilityServ.getObjectText(obj.SpecialInstructions);
        storeDetails.storeOpeningTime = this.utilityServ.getObjectText(obj.TimeForThisWeek);
        storeDetails.storedirections = this.utilityServ.getObjectText(obj.Directions);
        storeDetails.storedistance = this.utilityServ.getObjectText(obj.Distance);
        storeDetails.storemail = this.utilityServ.getObjectText(obj.Email);
        storeDetails.storeLimitations = this.utilityServ.getObjectText(obj.Limitations);
        storeDetails.storePhoneNumber = this.utilityServ.getObjectText(obj.PhoneNumber);
        storeDetails.storeRestrictions = this.utilityServ.getObjectText(obj.Restrictions);
        storeDetails.storeScheduleThisWeekThisWeek = this.utilityServ.getObjectText(obj.TimeForThisWeek);
        // this.sendMoneyService.getstoreimage(this.utilityServ.getObjectText(this.storepopupData.StoreID)).subscribe(data => {
        //   if (data.Envelope.Body.AgentStoreImageResponse.StatusCode == 1000) {
        //     //Need to write Image URL for Store
        //     //this.storeImageURL=data.
        //   }
        // });
        // storeDetails.storeimageurl = this.storeImageURL;
        return storeDetails;
    }

    ClickPickupType() {

        this.subModalpopup = this.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);

        this.router.navigate(['/repeatorder']);

        return;
    }

    ClickPaymentType() {
        this.subModalpopup = this.sendMoneyService.setModalPopup(SendMoneySteps.PaymentType);
        this.router.navigate(['/repeatorder']);
        return;
    }

    getCountryName(contryCode) {
        let CountryNames = this.countrycollection.filter(function (country) {
            return country.CountryCode === contryCode;
        });

        if (CountryNames.length > 0) {
            return CountryNames[0].CountryNames[0].Name;
        }
    }

    valueChangeForward(isFirstLoad: boolean = false) {

        if (isFirstLoad == true) {

            this.model.srcAmount = this.sendMoneyDetail.paymentDetails.srcAmount.toFixed(AppSettings.fractionDigit);
            this.model.destAmount = this.sendMoneyDetail.paymentDetails.destAmount.toFixed(this.RoundingPlaces || AppSettings.fractionDigit);

        } else {

            this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));

            this.loadBranchDetail();

            let subscription = this.observable.subscribe(branchInfoChanged => {

                if (subscription != undefined) {
                    subscription.unsubscribe();
                }

                if (branchInfoChanged === true) {
                    this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));
                }

                this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                this.isAmountExceed(this.sendMoneyDetail.paymentDetails.srcAmount);

            });
        }
    }

    private calculateFromLocalAmount(localAmount: number) {

        let maxAllowedLimit = this.sendMoneyDetail.paymentDetails.maxAllowedLimit;
        maxAllowedLimit = maxAllowedLimit != null && maxAllowedLimit !== undefined && !isNaN(maxAllowedLimit) ? maxAllowedLimit : 0;

        if (maxAllowedLimit > 0 && localAmount > maxAllowedLimit) {
            localAmount = maxAllowedLimit;
        }

        this.calculateFromTransferAmount(localAmount * this.Rate);

    }

    valueChangeBackward() {

        this.calculateFromTransferAmount(Number(this.model.destAmount || 0));

        this.loadBranchDetail();

        let subscription = this.observable.subscribe(branchInfoChanged => {

            if (subscription != undefined) {
                subscription.unsubscribe();
            }

            if (branchInfoChanged === true) {
                this.calculateFromTransferAmount(Number(this.model.destAmount || 0));
            }

            this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
            this.isAmountExceed(this.sendMoneyDetail.paymentDetails.srcAmount);

        });
    }

    private calculateFromTransferAmount(transferAmount: number) {

        let maxAllowedLimit = this.sendMoneyDetail.paymentDetails.maxAllowedLimit;
        maxAllowedLimit = maxAllowedLimit != null && maxAllowedLimit !== undefined && !isNaN(maxAllowedLimit) ? maxAllowedLimit : 0;

        if (maxAllowedLimit > 0) {
            transferAmount = (transferAmount / this.Rate) <= maxAllowedLimit ? transferAmount : maxAllowedLimit * this.Rate;
        }

        let minimumDenomination = this.sendMoneyDetail.paymentDetails.minimumDenomination;

        if (minimumDenomination > 0) {

            let ceilTransferAmount = Math.ceil(transferAmount / minimumDenomination) * minimumDenomination;
            let floorTransferAmount = Math.floor(transferAmount / minimumDenomination) * minimumDenomination;

            if (maxAllowedLimit > 0) {
                transferAmount = (ceilTransferAmount / this.Rate) <= maxAllowedLimit ? ceilTransferAmount : floorTransferAmount;
            } else {
                transferAmount = ceilTransferAmount;
            }
        }

        let localAmount = transferAmount / this.Rate;

        this.model.srcAmount = localAmount.toFixed(AppSettings.fractionDigit);
        this.model.destAmount = transferAmount.toFixed(this.RoundingPlaces || AppSettings.fractionDigit);

        this.sendMoneyDetail.paymentDetails.srcAmount = localAmount;
        this.sendMoneyDetail.paymentDetails.destAmount = Number(transferAmount.toFixed(this.RoundingPlaces || AppSettings.fractionDigit));
        this.sendMoneyDetail.paymentDetails.totalAmount = Number(localAmount.toFixed(AppSettings.fractionDigit)) + Number(this.Fee);
        this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);

    }

    isAmountExceed(amount: number) {
        let flag = true;
        let maxAllowedLimit = this.sendMoneyDetail.paymentDetails.maxAllowedLimit;
        maxAllowedLimit = maxAllowedLimit != null && maxAllowedLimit !== undefined && !isNaN(maxAllowedLimit) ? maxAllowedLimit : 0;
        // amount = amount + this.Fee;
        if (maxAllowedLimit == 0 || maxAllowedLimit > parseFloat(this.sendMoneyDetail.userDetails.maxTransferAmountLimit)) {
            flag = false;
        } else {
            flag = amount > maxAllowedLimit ? true : false;
        }
        if (flag) {
            let modalData: any = {};
            modalData.Title = this.translate.instant('Common_lblInfo').toString();
            modalData.Message =
                this.translate.instant('InputAmount_amountExceedPre') +
                ' ' +
                this.sendMoneyDetail.paymentDetails.srcCurrCode +
                ' ' +
                parseFloat(this.sendMoneyDetail.paymentDetails.maxAllowedLimit.toString()) +
                ' ' +
                this.translate.instant('InputAmount_amountExceedPost');
            modalData.Action = this.translate.instant('Common_lblOk').toString();
            if (this.isModalOpen == false) {
                this.isModalOpen = true;
                const _self = this;
                this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                    obj.onDestroy.subscribe(data => {
                        _self.isModalOpen = false;
                    });
                });
            }
            return true;
        } else {
            return false;
        }
    }

    isValidDenomination(amount: number) {
        let denomination = this.sendMoneyDetail.paymentDetails.minimumDenomination;
        denomination = denomination != null && denomination !== undefined && !isNaN(denomination) ? denomination : 0;
        if (denomination == 0) {
            return true;
        }
        if (amount % denomination == 0) {
            return true;
        } else {
            let modalData: any = {};
            modalData.Title = this.translate.instant('Common_lblInfo').toString();
            modalData.Message = this.translate.instant('InputAmount_errorDenominationDesc') + denomination;
            this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
            return false;
        }
    }

    openusertranscation(listIndex, BeneficiaryData) {

        // resetting model data
        this.model = {};
        this.sendMoneyDetail = new SendMoneyDetail();
        this.userStateService.getcurrentUserDetailData().subscribe(data => {
            this.sendMoneyDetail.userDetails = data;
        });
        this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
        this.selectedIndex = listIndex;
        this.getOrderDetails(BeneficiaryData);
        if (window.screen.width < Number(AppSettings.MOBILE_SCREEN_WIDTH)) {
            this.showBothScreen = true;
            this.mobileScreen = true;
        }
    }

    formatAmount(event) {
        event.currentTarget.value = this.amountFormat.transform(event.currentTarget.value); //this.amountFormat.transform(event.currentTarget.value); // event.currentTarget.value.replace('$', '');
    }

    revformatAmount(event) {
        event.currentTarget.value = event.currentTarget.value.replace(/[^0-9-.]/g, '');
        event.currentTarget.value = Number(event.currentTarget.value) == 0 ? '' : event.currentTarget.value;
    }

    ngOnDestroy() {
        if (this.subModalpopup != undefined) {
            this.subModalpopup.unsubscribe();
        }
        if (this.subSendMoneyDetail != undefined) {
            this.subSendMoneyDetail.unsubscribe();
        }
        if (this.subCurrentcartDetail != undefined) {
            this.subCurrentcartDetail.unsubscribe();
        }
    }

    retAmount(amount) {
        $(window).off('resize');
        // return amount.toString().replace(/[^0-9-.]/g, '');
        const val = amount.replace(/[^0-9-.]/g, '');
        return parseFloat(Number(val).toFixed(AppSettings.fractionDigit));
    }

    cancel() {
        let modalData: any = {};
        const _self = this;
        modalData.Title = this.translate.instant('Common_lblConfirm').toString();
        modalData.Message = this.translate.instant('SendMoneyCancelPopup_desc').toString();
        this.modal.overlay.defaultViewContainer = this.vcRef;
        return this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
            obj.onDestroy.subscribe(data => {
                //console.log('Observer got a next value: ' + data);
                if (modalData.next == 'yes') {
                    _self.sendMoneyService.setDeactivateSummaryFlag(true);
                    _self.router.navigate(['/dashboard']);
                }
            });
        });
    }

    supersendLoad() {
        let self = this;
        let modalData: any = {};
        this.actionFlag = false;

        modalData.srcAmount = this.sendMoneyDetail.paymentDetails.srcAmount;
        modalData.srcAmountIsDisabled = true;
        modalData.page = 'summary';
        modalData.LocationId = this.sendMoneyDetail.agentDetails.LocationId;
        modalData.CountrySupportedCurrencyCodesTo = this.sendMoneyDetail.agentDetails.CountrySupportedCurrencyCodesTo;
        modalData.ProgramId = this.sendMoneyDetail.agentDetails.ProgramId;
        modalData.DeliveryMethod = this.sendMoneyDetail.agentDetails.DeliveryMethod;
        modalData.CountryCodeTo = this.sendMoneyDetail.agentDetails.CountryTo;
        modalData.beneficiary = this.sendMoneyDetail.beneficiaryDetails;
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let reqObj: any = {};
        reqObj.CurrencyCodeTo = this.sendMoneyDetail.agentDetails.CurrencyTo;
        const _self = this;
        this.utilityServ.busy = this.utilityServ.busy = this.dbService.getProgramDetails(reqObj).subscribe(
            data => {
                if (data.StatusCode == 20001) {
                    return false;
                }
                if (data.StatusCode == 10000) {
                    //console.log("abre el modal de super send")
                    if (data.Programs != '' && data.Programs != 0) {
                        modalData.arrPrograms = data.Programs.split(',');
                        modalData.max = modalData.arrPrograms.length - 1;
                        // this.getSuperSendDetails();
                        return this.modal.open(DashboardSupersendComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => {
                                //console.log("Esta es la data de super send", data)
                                if (modalData.next === 'yes') {
                                    const subProgramDetailData = self.sendMoneyService.getSendMoneyProgramDetailData().subscribe(data => {
                                        self.sendMoneyDetail.sendMoneyProgramDetail = data;
                                        self.sendMoneyDetail.agentDetails.ProgramId = data.ProgramId;
                                        if (subProgramDetailData != undefined) {
                                            subProgramDetailData.unsubscribe();
                                        }
                                    });

                                    self.subSupersendCall.next(true);
                                } else {
                                    self.subSupersendCall.next(false);
                                }
                            });
                        });
                    } else {
                        self.subSupersendCall.next(false);
                    }
                } else {
                    self.subSupersendCall.next(false);
                }
            },
            error => { }
        );
    }

    ClickAddToCart() {

        if (this.LocalAmountChanged() || this.TransferAmountChanged()) {

            clearTimeout(this.timeout);

            this.srcRadio = this.LocalAmountChanged();
            this.dstRadio = this.TransferAmountChanged();

            this.TriggerAmountChanged();

            let subscription = this.observable.subscribe(() => {

                if (subscription != undefined) {
                    subscription.unsubscribe();
                }

                this.addToCart();

            });
        } else {
            this.addToCart();
        }
    }

    // main click event
    addToCart() {
        this.actionFlag = true;
        //this.valueChangeForward();
        if (this.sendMoneyDetail.paymentDetails.srcAmount <= 0) {
            this.errorPopup(this.translate.instant('AddToCartSuccess_title'), this.translate.instant('Common_lblAmountZero'));
            return false;
        }
        if (this.sendMoneyDetail.paymentDetails.destAmount <= 0) {
            this.errorPopup(this.translate.instant('AddToCartSuccess_title'), this.translate.instant('Common_lblDestinationAmountZero'));
            return false;
        }

        if (this.isAmountExceed(this.sendMoneyDetail.paymentDetails.srcAmount) && this.isValidDenomination(this.sendMoneyDetail.paymentDetails.destAmount)) {
            return false;
        }
        // check location is permissionable
        // this.geoGraphicalCheck();
        const _self = this;
        this.utilityServ.busy = this.geoloc.islocPermissionable().subscribe(data => {
                if (data == undefined) {
                    return;
                }
                if (data == true) {
                    // suprsend logic will go here
                    this.sendMoneyDetail.paymentDetails = this.sendMoneyDetail.paymentDetails;
                    this.supersendLoad();

                    const unsubsubSupersendCall = this.subSupersendCall.subscribe(useSuperSend => {

                        if (useSuperSend == true) {

                            this.loadBranchDetail();

                            this.subscription = this.observable.subscribe(branchInfoChanged => {

                                if (this.subscription != undefined) {
                                    this.subscription.unsubscribe();
                                }

                                if (branchInfoChanged === true) {

                                    this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));

                                    this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                                    this.isAmountExceed(this.sendMoneyDetail.paymentDetails.srcAmount);

                                    if (this.sendMoneyDetail.agentDetails.ProgramId == 0) {
                                        this.errorPopupWithOK(this.translate.instant('AddToCartSuccess_title'), this.translate.instant('ExchangeFeeReviewPopup_desc'));
                                        return false;
                                    }
                                }

                                this.addtoCartProcess();

                            });
                        } else {
                            this.addtoCartProcess();
                        }

                        if (unsubsubSupersendCall != undefined) {
                            unsubsubSupersendCall.unsubscribe();
                        }

                    });
                } else {
                    this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Message_areaPermissibleError'));
                    return false;
                }
            },
            error => { }
        );
    }

    addtoCartProcess() {
        this.addingtocart();
    }

    addingtocart() {
        this.addCartItem();
    }

       getErrorList(data: any): any[] {
    // Verifica si CoreError, Errors y ErrorList existen
    const coreError = data.Envelope.Body.AddToCartResponse.CoreError;
    if (!coreError) return [];
    
    const errors = coreError.Errors;
    if (!errors) return [];
    
    const errorList = errors.ErrorList;
    if (!errorList) return [];
    
    // Convierte a array si es un objeto único
    return Array.isArray(errorList) ? errorList : [errorList];
}

    addCartItem() {
        //console.log("Try to repeat jaja")
        let self = this;
        let userGioLocation = new UserGioLocation();
        this.geoloc.getGioLocation().subscribe(data => {
            userGioLocation = data;
            this.geoloc.setserGioLocation(data);
            this.sendMoneyDetail.roundingPlaces = this.RoundingPlaces;
            this.utilityServ.busy = this.cartservice.addCartItem(this.sendMoneyDetail, userGioLocation).subscribe(
                
                data => {
                    //console.log("status code order", data.Envelope.Body.AddToCartResponse.StatusCode)
                    //console.log("status code", data)

                    let errorList = [];
                    if (data.Envelope.Body.AddToCartResponse.StatusCode != enumStatusCodeList.SUCCESS) {
                            //console.log("status code order", data.Envelope.Body.AddToCartResponse.StatusCode)
                        //console.log("status code", data.Envelope.Body.AddToCartResponse.CoreError.Errors.ErrorList)
                        //console.log("status code lenght", data.Envelope.Body.AddToCartResponse.CoreError.Errors.ErrorList.length)

                        errorList = this.getErrorList(data); // Si no hay errores, array vacío

                        if (errorList.length > 0) {
                            // Extrae el código del primer error (8001 en tu ejemplo)
                            let firstErrorCode = errorList[0].Code.__text;
                            
                            // Modifica el StatusCode con el valor del primer error
                            data.Envelope.Body.AddToCartResponse.StatusCode = firstErrorCode;
                            
                            //console.log("Nuevo StatusCode:", data.Envelope.Body.AddToCartResponse.StatusCode); // Debería mostrar 8001
                        }
                    }

                    if (data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                        this.shopingCart = new ShopingCart();
                        this.sendMoneyDetail.shopingCartList = new Array<ShopingCart>(); //new ShopingCartList();
                        this.shopingCart.itemId = data.Envelope.Body.AddToCartResponse.ItemId;
                        this.sendMoneyDetail.shopingCartList.push(this.shopingCart);
                        this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                        let modalData: any = {};
                        modalData.Title = this.translate.instant('AddToCartSuccess_title').toString();
                        modalData.Action = this.translate.instant('Common_lblContinue');
                        //const RateExpiresOn = moment(data.Envelope.Body.AddToCartResponse.RateExpiresOn).format('dd-MM-yyyy ');
                        //const RateExpiresOn = written(this.sendMoneyDetail.currentCartDetail.CartExpiry, { lang: sessionStorage.langCode }); //data.Envelope.Body.AddToCartResponse.RateExpiresOn;
                        const RateExpiresOn = this.sendMoneyDetail.currentCartDetail.CartExpiry;
                        const ItemCount = data.Envelope.Body.AddToCartResponse.ItemCount;
                        let Message1 =
                            this.translate.instant('Common_lblExchangeRateDesc').toString() + ' <strong class="redColor">' + RateExpiresOn + ' ' + this.translate.instant('AddToCartSuccess_hourDesc') + '</strong>';
                        // Message1 = Message1.replace("ONE HOUR", RateExpiresOn);

                        let itemText = ItemCount > 1 ? this.translate.instant('AddToCartSuccess_itemsDesc') : this.translate.instant('AddToCartSuccess_itemDesc');
                        modalData.Message = Message1;

                        let Message2 = this.translate.instant('AddToCartSuccess_transPre').toString();
                        // Message2 += ' <strong class="redColor">' + written(ItemCount, { lang: sessionStorage.langCode });
                        Message2 += ' <strong class="redColor">' + ItemCount;
                        Message2 += ' ' + itemText + '</strong>';
                        Message2 += ' ' + this.translate.instant('AddToCartSuccess_transPost');

                        return self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => {
                                if (modalData.next == 'yes') {
                                    modalData.Message = Message2;
                                    return self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                                        obj.onDestroy.subscribe(data => {
                                            if (modalData.next == 'yes') {

                                                let unsub = self.sendMoneyService.getRepeatorderOldData().subscribe(data => {
                                                    self.oldOrderData = data;
                                                    if (unsub != undefined) {
                                                        unsub.unsubscribe();
                                                    }
                                                });
                                                let DeviceDetail = self.deviceService.getDeviceInfo();
                                                (<any>window).firebase
                                                    .analytics()
                                                    .logEvent("RepeatOrderModification", {
                                                        Platform: AppSettings.Platform,
                                                        Browser: DeviceDetail.browser,
                                                        OSVersion: DeviceDetail.os_version,
                                                        AppVersion: AppSettings.Appversion,
                                                        IsPickupTypeChanged: self.sendMoneyDetail.pickupTypeDetails.pickupType == self.oldOrderData.PickupType ? false : true,
                                                        IsPaymentTypeChanged: self.sendMoneyDetail.paymentDetails.paymentType == self.oldOrderData.PaymentType ? false : true,
                                                        IsAmountChanged: self.sendMoneyDetail.paymentDetails.srcAmount == self.oldOrderData.Amount ? false : true,
                                                        PickupType: self.loadPickupTypeText(self.sendMoneyDetail.pickupTypeDetails.pickupType),
                                                        PaymentType: self.loadPaymentTypeText(self.sendMoneyDetail.paymentDetails.paymentType),
                                                        Amount: self.sendMoneyDetail.paymentDetails.srcAmount,
                                                        OrderNumber: self.shopingCart.itemId
                                                    });

                                                self.sendMoneyService.setDeactivateSummaryFlag(true);
                                                self.router.navigate(['/shoppingcart']);
                                            }
                                        });
                                    });
                                }
                            });
                        });
                        
                    } else if (data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.fieldsRequiredInOrder) {
                        //console.log("entra a campos requeridos", data.Envelope.Body)
                        if (
                                errorList.length > 0
                            ) {
                                // Recorre el arreglo y extrae los valores de `Field.__text`
                                const fieldsText = errorList
                                    .map(error => error.Field.__text) 
                                    .filter(Boolean)
                                    .join(', ');

                                //console.log("Campos con errores:", fieldsText);
                                this.openMissingInfo(fieldsText);
                            } else {
                            //console.log("No hay campos con errores.");
                        }
                        
                    } else if (data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.ComplianceError) {
                        let modalData: any = {};
                        modalData.Title = this.translate.instant('Common_lblOops').toString();
                        modalData.Action = this.translate.instant('Common_lblOk');
                        modalData.Message = data.Envelope.Body.AddToCartResponse.StatusMessage;
                        this.modal.overlay.defaultViewContainer = this.vcRef;
                        return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => { });
                        });
                    } else if (
                        data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.Invalid_bank_account1 ||
                        data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.Invalid_bank_account2
                    ) {
                        let modalData: any = {};
                        modalData.Title = this.translate.instant('Common_lblOops').toString();
                        modalData.Action = this.translate.instant('Common_lblOk');
                        modalData.Message = this.translate.instant('AddToCartFailure_Code_9071_9072');
                        this.modal.overlay.defaultViewContainer = this.vcRef;
                        return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => { });
                        });
                    } else {
                        let modalData: any = {};
                        modalData.Title = this.translate.instant('Common_lblOops').toString();
                        modalData.Action = this.translate.instant('Common_lblOk');
                        modalData.Message = this.translate.instant('AddToCartFailure_cartFailDesc');
                        // data.Envelope.Body.AddToCartResponse.StatusMessage;
                        this.modal.overlay.defaultViewContainer = this.vcRef;
                        return this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => { });
                        });
                    }
                },
                error => { }
            );
        });
    }

  // open modal to fill required additional information
    openMissingInfo(data: string) {
        let additionalRequiredFields: AdditionalRequired = new AdditionalRequired();
        let paramsRequired: any = data.split(',').map(item => item.trim()); 

        let flag: boolean = false;
        paramsRequired.forEach(element => {
            switch (element) {
                case 'CustomerOccupation':
                    additionalRequiredFields.IsCustomerOccupationRequired = true;
                    flag = true;
                    break;
                case 'CustomerEmployer':
                    additionalRequiredFields.IsCustomerEmployerRequired = true;
                    flag = true;
                    break;
                case 'FundSource':
                    additionalRequiredFields.IsFundSourceRequired = true;
                    flag = true;
                    break;
                case 'TransferReason':
                    additionalRequiredFields.IsTransferReasonRequired = true;
                    flag = true;
                    break;
                case 'BeneficiaryRelation':
                    additionalRequiredFields.IsBeneficiaryRelationRequired = true;
                    flag = true;
                    break;
                case 'Beneficiary_Address':
                    additionalRequiredFields.IsBeneficiaryAddressRequired = true;
                    flag = true;
                    break;
                default:
                    break;
            }
        });

        if (flag) {
            const modalData: any = {};
            modalData.page = 'summary';
            const _self = this;
            this.sendMoneyDetail.branchDetails.SummaryValidation = additionalRequiredFields;
            this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
            this.modal.overlay.defaultViewContainer = this.vcRef;
            return this.modal.open(AdditionalInfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.onNext == 'yes') {
                        //_self.addToCart(type);
                        _self.addtoCartProcess();
                    }
                });
            });
        }
    }

    errorPopup(title, message) {
        let modalData: any = {};
        modalData.Title = title;
        modalData.Message = message;
        this.modal.overlay.defaultViewContainer = this.vcRef;
        this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
    }
    errorPopupWithOK(title, message) {
        let modalData: any = {};
        modalData.Title = title;
        modalData.Message = message;
        modalData.Action = this.translate.instant('Common_lblOk');
        this.modal.overlay.defaultViewContainer = this.vcRef;
        this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
    }

    loadBranchDetail() {
        //console.log("Es el 6");
        this.sendMoneyDetail.agentDetails.Amount = this.sendMoneyDetail.paymentDetails.srcAmount;
        this.utilityServ.busy = this.sendMoneyService.getBranchDetails(this.sendMoneyDetail.agentDetails).subscribe(
            data => {
                if (data.StatusCode == 10000 && data.Branches != null) {
                    this.isBranchDetailsUpdated = true;
                    if (Number(this.sendMoneyDetail.paymentDetails.exchangeRate) != Number(data.Branches[0].RateCustomer) || Number(this.sendMoneyDetail.paymentDetails.processingFee) != Number(data.Branches[0].CustomerFee) || Number(this.sendMoneyDetail.paymentDetails.TaxAmount) != Number(data.Branches[0].TaxAmount)) {
                        this.sendMoneyDetail.branchDetails = data.Branches[0];
                        this.sendMoneyDetail.branches = data.Branches;

                        this.sendMoneyDetail.paymentDetails.processingFee = parseFloat(this.sendMoneyDetail.branchDetails.CustomerFee.toString());
                        this.sendMoneyDetail.paymentDetails.exchangeRate = this.sendMoneyDetail.branchDetails.RateCustomer.toString();
                        this.sendMoneyDetail.paymentDetails.TaxAmount = this.sendMoneyDetail.branchDetails.TaxAmount;
                        this.sendMoneyDetail.paymentDetails.TaxDetails = this.sendMoneyDetail.branchDetails.TaxDetails;
                        this.Rate = Number(this.sendMoneyDetail.paymentDetails.exchangeRate);
                        this.Fee = this.sendMoneyDetail.paymentDetails.processingFee;
                        this.TaxAmount = this.sendMoneyDetail.paymentDetails.TaxAmount;
                        if (this.sendMoneyDetail.branchDetails.MinimumDenomination != null) {
                            this.sendMoneyDetail.paymentDetails.minimumDenomination = parseFloat(this.sendMoneyDetail.branchDetails.MinimumDenomination.toString());
                        } else {
                            this.sendMoneyDetail.paymentDetails.minimumDenomination = 0;
                        }

                        if (this.sendMoneyDetail.branchDetails.MaximumLocalAmount != null) {
                            this.sendMoneyDetail.paymentDetails.maxAllowedLimit = parseFloat(this.sendMoneyDetail.branchDetails.MaximumLocalAmount.toString());
                        } else {
                            this.sendMoneyDetail.paymentDetails.maxAllowedLimit = 0;
                        }

                        if (!this.sendMoneyDetail.branchDetails.MaximumLocalAmountExcludeFee && this.sendMoneyDetail.paymentDetails.maxAllowedLimit > 0) {
                            this.sendMoneyDetail.paymentDetails.maxAllowedLimit = this.sendMoneyDetail.paymentDetails.maxAllowedLimit - this.Fee;
                        }

                        if (this.sendMoneyDetail.paymentDetails.maxAllowedLimit == 0 || this.sendMoneyDetail.paymentDetails.maxAllowedLimit > parseFloat(this.sendMoneyDetail.userDetails.maxTransferAmountLimit)) {
                            this.sendMoneyDetail.paymentDetails.maxAllowedLimit = parseFloat(this.sendMoneyDetail.userDetails.maxTransferAmountLimit);
                        }

                        // this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                        // return true;
                        //this.valueChangeForward();
                        // if (this.actionFlag) {
                        this.clickStream.next(true);
                        // }
                    } else {
                        // return false;
                        // if (this.actionFlag) {
                        this.clickStream.next(false);
                        // }
                    }
                } else {
                    this.isFormValid = false;
                    const _self = this;
                    let modalData: any = {};
                    modalData.Action = this.translate.instant('Common_lblOk');
                    modalData.Title = this.translate.instant('Common_lblOops').toString();
                    modalData.Message = this.translate.instant('Message_errorMessage').toString();
                    this.modal.overlay.defaultViewContainer = this.vcRef;
                    return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                        obj.onDestroy.subscribe(data => {
                            //console.log('Observer got a next value: ' + data);
                            if (modalData.next == 'yes') {
                                _self.sendMoneyService.setDeactivateSummaryFlag(true);
                                _self.router.navigate(['/dashboard']);
                            }
                        });
                    });
                }
            },
            error => {
                //console.log('Observer got a next value: ' + error);
            }
        );
    }

    openTaxesDetail() {
    let modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblTaxDetails'); 
    modalData.Message = "";

    if (this.sendMoneyDetail.branchDetails.TaxDetails == null || this.sendMoneyDetail.branchDetails.TaxDetails.length === 0) {
        modalData.Message = this.translate.instant('Common_lblNoTax'); 
    } else {
        // Mapear cada elemento del array a una cadena con el formato "Name: $Amount"
        const taxMessages = this.sendMoneyDetail.branchDetails.TaxDetails.map(tax => {
            return `${tax.Name}: $${tax.Amount.toFixed(2)}`; // toFixed(2) para mostrar 2 decimales
        });
        
        // Unir todos los mensajes con <br> como separador
        modalData.Message = taxMessages.join('<br>');
    }
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }

    getAccountNumber() {
        let str = this.sendMoneyDetail.bankAccountDetails.BankAccountNumber.toString();
        return ' XXXX-XXXX-XXXX-' + str.substring(str.length - 4);
    }

    loadPickupTypeText(type) {
        let classVal;
        switch (parseInt(type, 0)) {
            case PickupType.atmDeposit: {
                classVal = "AtmDeposit";
                break;
            }
            case PickupType.bankDeposit: {
                classVal = "BankDeposit";
                break;
            }
            case PickupType.homeDelivery: {
                classVal = "HomeDelivery";
                break;
            }
            case PickupType.officePickup: {
                classVal = "OfficePickup";
                break;
            }
        }
        return classVal;
    }

    loadPaymentTypeText(type) {
        let classVal;
        switch (parseInt(type, 0)) {
            case PaymentType.DebitCard: {
                classVal = "DebitCard";
                break;
            }
            case PaymentType.PayAtStore: {
                classVal = "PayAtStore";
                break;
            }
        }
        return classVal;
    }
}

enum branchStatus {
    unknown = 0,
    branchAvailable = 1,
    branchAmountExeed = 2,
    branchNotAvailable = 3,
    branchNotExist = 4
}




// WEBPACK FOOTER //
// ./src/app/repeatorder/repeatorderlist/repeatorderlist.component.ts